export default "__VITE_ASSET__P8p73Z_S__"